import { render } from "./homeComponent.vue?vue&type=template&id=fb9d0722"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__